<template>
  <div>
    <div class="dialog--custom-mask"></div>
    <v-dialog v-model="open" persistent max-width="740px" :hide-overlay="this.$route.fullPath.includes('details')"
              attach="RealizationModal">
      <v-card>
        <form @submit.prevent="!isProcessing ? onSubmit() : null" novalidate>
          <v-card-title>
            <span class="headline">Dodawanie realizacji</span>
          </v-card-title>
          <v-card-text>
            <v-container class="pt-0" grid-list-md>
              <v-layout v-for="ticketItem in this.formDataItems.items" :key="ticketItem.number" wrap>
                <v-flex xs1 sm1>
                  <v-checkbox
                      label=""
                      v-model="ticketItem.used"
                      browser-autocomplete="off">
                  </v-checkbox>
                </v-flex>
                <v-flex xs11 sm3>
                  <v-menu
                      :close-on-content-click="false"
                      v-model="usedPicker[ticketItem.number]"
                      :nudge-right="40"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      min-width="290px"
                  >
                    <v-text-field
                        slot="activator"
                        v-model="ticketItem.used_at"
                        label="Wybierz datę"
                        readonly
                    ></v-text-field>
                    <v-date-picker
                        v-model="ticketItem.used_at"
                        @input="usedPicker[ticketItem.number] = false"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-text-field
                      label="Uwagi"
                      v-model="ticketItem.description"
                      browser-autocomplete="off">
                  </v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="grey darken-1" flat @click="goBack(); ">Anuluj</v-btn>
            <v-btn color="blue darken-1" :disabled="isProcessing" flat type="submit">Zapisz</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable no-unused-expressions */

import {mapActions} from 'vuex';

export default {
  name: 'AddRealization',
  data() {
    return {
      open: true,
      ticketRealizationDatePicker: false,
      isProcessing: false,
      // attachTo: null,
      formDataItems: {},
      usedPicker: {
        1: false,
        2: false,
        3: false,
        4: false,
        5: false,
        6: false,
        7: false,
        8: false,
        9: false,
        10: false,
      },
    };
  },
  watch: {
    $route(from) {
      if (from.name === 'AddRealization') {
        this.loading = true;
        this.fetchTicketItems(this.$route.params.ticketId)
            .then((response) => {
              this.ticketDetails = response;
              this.loading = false;
            });
      }
    },
  },
  mounted() {
    this.fetchTicketItems(this.$route.params.ticketId)
        .then((response) => {
          this.formDataItems = response;
          this.loading = false;
        });
  },
  methods: {
    ...mapActions('TicketStore', ['editTicketItems', 'fetchTicketItems']),
    goBack() {
      this.$route.fullPath.includes('details') ? this.$router.push({
        name: 'TicketDetails',
        params: {ticketId: this.$route.params.ticketId},
      }) : this.$router.push({name: 'Tickets'});
    },

    onSubmit() {
      this.$validator.validateAll()
          .then((isValid) => {
            if (isValid) {
              this.isProcessing = true;
              const formData = {
                id: this.$route.params.ticketId,
                ...this.formDataItems,
              };
              this.editTicketItems(formData)
                  .then(() => {
                    this.goBack();
                    this.isProcessing = false;
                  }, () => {
                    this.isProcessing = false;
                  });
            }
          });
    },
  },
};
</script>
